import type { WorkshopNavItem } from '../../workshop/workshopNavTypes';

/**
 * Payroll "Reporting" menu entries, shared by the desktop top-nav dropdown (OdooTopNav)
 * and the mobile drawer (OdooShellMobileNav). Each item routes to `/{resource}` inside the
 * Payroll workspace, matching the Auto Workshop reports convention (one manifest resource
 * per report, so each report carries its own permission key).
 */
export const PAYROLL_REPORTS_NAV: WorkshopNavItem[] = [
    { resource: 'salarySheetReport', label: 'Salary Sheet' },
];
